<template>
    <div>
        <div v-if="loadingParams">
            <div class="loading">
                <img src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading" />
            </div>
        </div>
        <template v-else>
            <div class="finance-calculator">
                <div class="finance-calculator__grid container">
                    <div class="finance-calculator__sidebar">
                        <div class="finance-calculator__card finance-calculator__card--blue">
                            <form ref="finance-form">
                                <h2 class="h2 h2--white">Finance Calculator</h2>

                                <div class="finance-calculator__form-group form-group">
                                    <label class="finance-calculator__label" for="finance-type">Finance type</label>
                                    <select name="finance-type" class="form-control" v-model="financeType">
                                        <option v-for="option in financeParams" :key="option.key" :value="option.key"
                                            v-html="option.longName"></option>
                                    </select>
                                </div>
                                <div class="finance-calculator__form-group form-group">
                                    <label class="finance-calculator__label" for="pcp-deposit">Deposit</label>
                                    <input type="text" v-currency="{ currency: 'GBP', locale: 'en' }" ref="depositInput"
                                        v-model="depositInput" class="form-control" />
                                </div>

                                <div class="finance-calculator__form-group form-group">
                                    <label class="finance-calculator__label" for="pcp-term-select">Choose the length of your
                                        contract</label>

                                    <div class="finance-calculator__button-group">
                                        <button v-for="selectedFinanceTerm in availableTerms"
                                            :key="`term-${selectedFinanceTerm}`" @click="setTerm(selectedFinanceTerm)" :class="{
                                                'finance-calculator__button': true,
                                                'finance-calculator__button--active': selectedFinanceTerm == term,
                                            }" type="button">{{ selectedFinanceTerm }} months</button>
                                    </div>
                                </div>


                                <div class="finance-calculator__form-group form-group" v-if="financeType != 'HP'">
                                    <label class="finance-calculator__label" for="pcp-mileage-select">Choose an annual
                                        mileage</label>
                                    <select name="mileage" class="form-control" v-model.number="mileage">
                                        <option v-for="mileageOption in selectedFinance.mileage" :key="mileageOption"
                                            :value="mileageOption">{{ mileageOption }} miles</option>
                                    </select>
                                </div>
                            </form>

                            <button :disabled="loadingFinance" type="button" class="btn btn--primary btn--full-width" :class="{ 'btn--disabled': loadingFinance }" @click="openEnquireNowForm(true)">Enquire Now</button>

                            <button type="button" class="btn btn--primary btn--full-width" @click="navigateToReserveOnline()" :disabled="reserveOnlineDisabled">
                                <template v-if="reserveOnlineDisabled"> Vehicle Reserved </template>
                                <template v-else> Reserve Online </template>
                            </button>
                        </div>
                    </div>

                    <div class="finance-calculator__card rd-card rd-card--border-top">
                        <div v-if="loadingFinance" class="loading" id="finance-loading"><img
                                src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Finance" /></div>
                        <FinanceQuote v-else :quote="financeQuote" :loading="loadingFinance" :term="term" :mileage="mileage"
                            :deposit="deposit" :vehicle="vehicle" :term-changed="termChanged" :mileage-changed="mileageChanged"
                            :brand-p-c-p-finance-name="brandPCPFinanceName" :apply-online-disabled="applyOnlineDisabled"
                            v-on:scroll-to="$emit('scroll-to', 'valuation')" v-on:contact-dealer="$emit('contact-dealer')" />
                    </div>
                    <!-- <div class="finance-calculator__card rd-card rd-card--border-top">
                        <div v-if="loadingFinance" class="loading" id="finance-loading"><img
                                src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Finance" /></div>
                        <FinanceQuote v-else :quote="financeQuote" :loading="loadingFinance" :term="term" :mileage="mileage"
                            :deposit="deposit" :vehicle="vehicle" :term-changed="termChanged" :mileage-changed="mileageChanged"
                            :brand-p-c-p-finance-name="brandPCPFinanceName" :apply-online-disabled="applyOnlineDisabled"
                            v-on:scroll-to="$emit('scroll-to', 'valuation')" v-on:contact-dealer="$emit('contact-dealer')" />
                    </div> -->
                </div>

                <!-- <FinanceCallToActions v-on:enquire-now="openEnquireNowForm(true)" :quote="financeQuote" :vehicle="vehicle"
                    :apply-online-disabled="applyOnlineDisabled" /> -->

                <FinanceTerms :vehicle="vehicle" :financeType="financeType" :quoteValidFrom="quoteValidFrom"
                    class="finance-calculator__terms-mobile terms container" />

                <EnquireNowForm
                    :open="enquireNowFormOpen"
                    :vehicle="vehicle"
                    :quote="financeQuote"
                    :term="term"
                    :deposit="deposit"
                    :mileage="mileage"
                    @close="enquireNowFormOpen = false"
                />
            </div>
        </template>
    </div>
</template>

<script>
import getFinanceParameters from "../../api/finance/GetFinanceParameters";
import getFinanceNameFromKey from "../../api/finance/GetFinanceNameFromKey";
import UsedVehicleFinanceAPI from "../../api/finance/UsedVehicleFinance";
import FinanceCallToActions from "./FinanceCallToActions.vue";
import FinanceQuote from "./FinanceQuote.vue";
import FinanceTerms from "./FinanceTerms.vue";
import EnquireNowForm from "./Quotes/EnquireNowForm.vue";
import { CurrencyDirective, getValue } from "vue-currency-input";
import { mapState } from "vuex";
import debounce from "lodash/debounce";
import { format } from "date-fns";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        FinanceCallToActions,
        FinanceQuote,
        FinanceTerms,
        EnquireNowForm,
    },
    directives: {
        currency: CurrencyDirective,
    },
    props: {
        vehicle: {
            required: true,
        },
        applyOnlineDisabled: {
            required: false,
        },
        isReserved: {
            type: Boolean,
            required: false,
            default: false,
        },
        reserveOnlineDisabled: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            api: new UsedVehicleFinanceAPI({
                collect_only_once: false,
            }),
            // Using Vehicle Array as a simple array containing this.vehicle so we can supply it to UsedVehicleFinanceAPI in the same way the search results work
            vehicleArray: [this.vehicle],
            loadingFinance: true,
            financeParams: null,
            financeType: null,
            payment: null,
            brandPCPFinanceName: getFinanceNameFromKey(this.vehicle, "PCP"),
            enquireNowFormOpen: false,
            termChanged: false,
            mileageChanged: false,
            depositInput: 0,
        };
    },
    computed: {
        ...mapState("FinanceParameters", {
            personalQuote: "modified",
        }),
        ...mapState("Valuations", ["selectedValuation"]),
        deposit: {
            get: function () {
                return this.$store.getters["FinanceParameters/deposit"](this.vehicle, this.financeType);
            },
            set: debounce(function (newValue) {
                this.$store.commit("FinanceParameters/setFinanceDeposit", newValue);
                this.getFinance();
            }, 500),
        },
        availableTerms() {
            const termsLength = this.selectedFinance.terms.length;
            if (termsLength <= 6) {
                return this.selectedFinance.terms;
            }
            const minTerm = parseInt(this.selectedFinance.terms[0]);
            const maxTerm = parseInt(this.selectedFinance.terms[termsLength - 1]);
            const terms = [
                minTerm,
            ];
            const interval = termsLength / 6;
            let indexToAdd = interval;
            while (indexToAdd < termsLength) {
                terms.push(this.selectedFinance.terms[Math.ceil(indexToAdd)]);
                indexToAdd += interval;
            }
            terms.push(maxTerm);
            return terms;
        },
        term: {
            get: function () {
                let currentTerm = this.$store.getters["FinanceParameters/term"](this.vehicle.brand, this.financeType);
                if (typeof this.selectedFinance.terms == "undefined") {
                    return currentTerm;
                }
                // Ensure term matches
                let termFound = false;
                this.termChanged = false;
                let nearestTerm = this.selectedFinance.terms[0];
                for (let index = 0, len = this.selectedFinance.terms.length; index < len; index++) {
                    if (termFound) {
                        continue;
                    }
                    if (this.selectedFinance.terms[index] == currentTerm) {
                        termFound = true;
                        continue;
                    }
                    if (Math.abs(currentTerm - this.selectedFinance.terms[index]) < Math.abs(currentTerm - nearestTerm)) {
                        nearestTerm = this.selectedFinance.terms[index];
                    }
                }
                if (!termFound) {
                    this.termChanged = currentTerm;
                    currentTerm = nearestTerm;
                    this.$store.commit("FinanceParameters/setFinanceTerm", currentTerm);
                }
                return currentTerm;
            },
            set: function (newValue) {
                this.$store.commit("FinanceParameters/setFinanceTerm", newValue);
                this.getFinance();
            },
        },
        mileage: {
            get: function () {
                let currentMileage = this.$store.getters["FinanceParameters/mileage"](this.vehicle.brand, this.financeType);
                // If we have no params from CW for the mileage list, then just return the current mileage
                if (typeof this.selectedFinance.mileage == "undefined") {
                    return currentMileage;
                }
                // Go through the allowed mileage values and determine if the currently selected mileage exists in the list. If it doesn't, find the closest match
                let mileageFound = false;
                this.mileageChanged = false;
                let nearestMileage = this.selectedFinance.mileage[0];
                for (let index = 0, len = this.selectedFinance.mileage.length; index < len; index++) {
                    if (mileageFound) {
                        continue;
                    }
                    if (this.selectedFinance.mileage[index] == currentMileage) {
                        mileageFound = true;
                        continue;
                    }
                    if (Math.abs(currentMileage - this.selectedFinance.mileage[index]) < Math.abs(currentMileage - nearestMileage)) {
                        nearestMileage = this.selectedFinance.mileage[index];
                    }
                }
                // If the mileage wasn't found in the list, use the nearest match and set mileageChanged to the old mileage. mileageChanged is passed into the FinanceAdjustmentNotifications component and renders a notification message
                if (!mileageFound) {
                    this.mileageChanged = currentMileage;
                    currentMileage = nearestMileage;
                    this.$store.commit("FinanceParameters/setFinanceMileage", currentMileage);
                }
                return currentMileage;
            },
            set: function (newValue) {
                this.$store.commit("FinanceParameters/setFinanceMileage", newValue);
                this.getFinance();
            },
        },
        selectedFinance() {
            if (this.financeParams == null || this.financeParams.length == 0) {
                return false;
            }
            for (let index = 0, len = this.financeParams.length; index < len; index++) {
                if (this.financeParams[index].key == this.financeType) {
                    return this.financeParams[index];
                }
            }
            return false;
        },
        loadingParams() {
            if (this.financeParams == null) {
                return true;
            }
            return false;
        },
        quoteValidFrom() {
            return format(new Date(), "Do MMMM YYYY");
        },
        financeQuote() {
            if (typeof this.vehicleArray[0] == "undefined") {
                return false;
            }
            // if (typeof this.vehicleArray[0].is_new != 'undefined' && this.vehicleArray[0].is_new == 1) {
            //     return false;
            // }
            if (typeof this.vehicleArray[0].is_new != "undefined" && this.vehicleArray[0].is_new == 1 && typeof this.vehicleArray[0].display_finance != "undefined" && this.vehicleArray[0].display_finance == 0) {
                return false;
            }
            if (typeof this.vehicleArray[0].finance == "undefined") {
                return false;
            }
            if (typeof this.vehicleArray[0].finance.FinanceProductResults == "undefined") {
                return false;
            }
            if (typeof this.vehicleArray[0].finance.FinanceProductResults.length == 0) {
                return false;
            }
            for (let index = 0, len = this.vehicleArray[0].finance.FinanceProductResults.length; index < len; index++) {
                if (typeof this.vehicleArray[0].finance.FinanceProductResults[index].Key !== "undefined" && this.vehicleArray[0].finance.FinanceProductResults[index].Key == this.financeType) {
                    window.sessionStorage.setItem(
                        "financeObject",
                        JSON.stringify({
                            vehicleId: this.vehicle.id,
                            quote: this.vehicleArray[0].finance.FinanceProductResults[index],
                        })
                    );

                    return this.vehicleArray[0].finance.FinanceProductResults[index];
                }
            }
            return false;
        },
    },
    methods: {
        getFinance() {
            this.loadingFinance = true;
            this.$nextTick(function () {
                this.api.setKeys({
                    new: [this.financeType],
                    used: [this.financeType],
                });
                this.api.setTerm(this.$store.getters["FinanceParameters/term"](this.vehicle.brand, this.financeType));
                this.api.setDeposit(this.$store.getters["FinanceParameters/deposit"](this.vehicle, this.financeType));
                this.api.setMileage(this.$store.getters["FinanceParameters/mileage"](this.vehicle.brand, this.financeType));
                this.$emit("finance-updated", "loading");
                this.api
                    .getFinance()
                    .then((d) => {
                        this.loadingFinance = false;
                        Vue.set(this.vehicleArray, 0, d[0]);
                        this.$emit("finance-updated", d[0]);
                        // this.vehicleArray = d;
                    })
                    .catch((d) => {
                        console.error("error calling getFinance()", d);
                        this.loadingFinance = false;
                        Vue.set(this.vehicleArray, 0, d[0]);
                        this.$emit("finance-updated", d[0]);
                    });
            });
        },
        openEnquireNowForm(openOrClosed) {
            if (openOrClosed) {
                this.gaTag("Used Vehicle Details", "Finance Enquire Now", "Opened");
            } else {
                this.gaTag("Used Vehicle Details", "Finance Enquire Now", "Closed");
            }
            this.enquireNowFormOpen = openOrClosed;
        },
        setTerm(term) {
            this.term = term;
        },
        navigateToReserveOnline() {
            if (this.reserveOnlineDisabled) {
                console.error("Cannot reserve vehicle");
                return;
            }

            customEvent(this.customEventCategory, 'Clicked', 'Reserve Online CTA');
            this.$router.push({ name: 'reserve-online-landing', params: { id: this.vehicle.id } });
        },
    },
    watch: {
        financeType(val, oldVal) {
            this.getFinance();
        },
        selectedValuation(val, oldVal) {
            this.getFinance();
        },
        depositInput(val, oldVal) {
            if (typeof val == "string") {
                if (this.$refs.depositInput) {
                    val = getValue(this.$refs.depositInput);
                } else {
                    val = parseFloat(val);
                }
            }
            if (typeof val == "undefined" || val === null) {
                val = 0;
            }
            if (val < 0) {
                val = 0;
            }
            const currentValue = this.$store.getters["FinanceParameters/deposit"](this.vehicle, this.financeType) || 0;
            if (currentValue !== val) {
                this.deposit = val;
            }
        },
    },
    mounted() {
        if (window.location.hash == "#personalise-finance" || (this.$route.query && this.$route.query.key)) {
            this.$emit("mounted", false);
        }
    },
    created() {
        this.depositInput = this.$store.getters["FinanceParameters/deposit"](this.vehicle, this.financeType);

        this.api.setVehicles(this.vehicleArray);
        // getCustomerParameters();
        if (this.$route.query && this.$route.query.deposit) {
            this.depositInput = this.$route.query.deposit;
            this.$store.commit("FinanceParameters/setFinanceDeposit", this.$route.query.deposit);
        }
        if (this.$route.query && this.$route.query.term) {
            this.$store.commit("FinanceParameters/setFinanceTerm", this.$route.query.term);
        }
        if (this.$route.query && this.$route.query.mileage) {
            this.$store.commit("FinanceParameters/setFinanceMileage", this.$route.query.mileage);
        }
        // Load in finance parameters for this vehicle from Codeweavers
        // These are used to determine which finance keys are available, and what the term/deposit/mileage is for each key
        getFinanceParameters(this.vehicle)
            .then(financeParams => {
                if (financeParams.length > 0) {
                    let hasPsaOrVauxhallKey = false;
                    Object.keys(financeParams).forEach((index) => {
                        if (financeParams[index].key == 'PSA_PCP_ONLY' || financeParams[index].key == 'VAUXHALL_PCP_ONLY') {
                            hasPsaOrVauxhallKey = true;
                        }
                    });
                    // We only want a single PCP key in the results, not both PSA_PCP_ONLY and DSG_PCP_ONLY
                    let prunedFinanceParams = [];
                    Object.keys(financeParams).forEach((index) => {
                        if (financeParams[index].key == 'PSA_PCP_ONLY' || financeParams[index].key == 'VAUXHALL_PCP_ONLY') {
                            prunedFinanceParams.push(financeParams[index]);
                            return;
                        }
                        if (financeParams[index].key == 'DSG_PCP_ONLY') {
                            if (!hasPsaOrVauxhallKey) {
                                prunedFinanceParams.push(financeParams[index]);
                            }
                            return;
                        }
                        prunedFinanceParams.push(financeParams[index]);
                    });

                    this.financeParams = prunedFinanceParams;
                } else {
                    this.financeParams = null;
                }

                // If we have a deep linked finance, then try to use that key if it's available
                let financeTypeFromRoute = false;
                if (this.$route.query && this.$route.query.key) {
                    for (let index = 0, len = financeParams.length; index < len; index++) {
                        if (financeParams[index].key.toLowerCase() == this.$route.query.key.toLowerCase()) {
                            financeTypeFromRoute = this.$route.query.key;
                        }
                    }
                }
                // Since we're watching this.financeType, make sure we only update it once
                this.financeType = financeTypeFromRoute === false ? financeParams[0].key : this.$route.query.key;
            })
            .catch((error) => {
                console.error("FinanceCalculator@created: getFinanceParameters error", error);
                this.financeParams = null;
                this.$emit("have-finance-updated", false);
            });
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/redesign/variables";

.finance-calculator {
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #eff7ef;

    &__grid {
        display: grid;
        gap: 16px;
        grid-template-columns: minmax(0, 1fr);

        @media (min-width: $screen-md) {
            grid-template-columns: 345px repeat(2, minmax(0, 1fr));
        }
    }

    &__title {
        font-size: 16px;
        font-weight: 700;
    }

    &__card {
        display: flex;
        flex-direction: column;
        padding: 25px;
        border-radius: $default-card-border-radius;
        gap: 15px;

        &--blue {
            background-color: $dark-blue;
            color: #ffffff;
        }
    }

    &__form-group {
        display: flex;
        flex-direction: column;
        margin-top: 15px;
    }

    &__label {
        font-weight: 400;
        font-size: 16px;
        text-align: left;
        display: block;
        margin-bottom: 5px;
    }

    &__button-group {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 15px;
    }

    &__button {
        height: 45px;
        background: none;
        border: 0.5px solid #ffffff;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        cursor: pointer;
        color: #ffffff;

        &--active {
            background: #ffffff;
            color: $blue;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/FinanceCalculator.vue